'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMeasure = require('react-measure');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chromosomeMap = _utils.chromosomesWithCumulativeLengths.reduce(function (acc, d) {
  acc[d.name] = d;
  return acc;
}, {});
var chromosomeLabelWidthThreshold = 700;

var ManhattanFlat = function ManhattanFlat(_ref) {
  var measureRef = _ref.measureRef,
      data = _ref.data,
      contentRect = _ref.contentRect,
      _onClick = _ref.onClick;
  var width = contentRect.bounds.width;

  var height = 20;
  return _react2.default.createElement(
    'div',
    { ref: measureRef },
    _react2.default.createElement(
      'svg',
      { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
      width ? _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'g',
          null,
          _utils.chromosomesWithCumulativeLengths.map(function (d, i) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: 'chr' + d.name },
              _react2.default.createElement('rect', {
                x: d.proportionalStart * width,
                y: 0,
                width: (d.proportionalEnd - d.proportionalStart) * width,
                height: height,
                fill: i % 2 === 0 ? _theme2.default.track.background : _theme2.default.track.backgroundAlternate
              }),
              width > chromosomeLabelWidthThreshold ? _react2.default.createElement(
                'text',
                {
                  x: (d.proportionalStart + d.proportionalEnd) * width / 2,
                  y: height / 2,
                  fill: 'white',
                  fontSize: 10,
                  fontWeight: 'bold',
                  textAnchor: 'middle',
                  dominantBaseline: 'middle'
                },
                d.name
              ) : null
            );
          })
        ),
        _react2.default.createElement(
          'g',
          null,
          data.map(function (d) {
            var c = chromosomeMap[d.chromosome];
            var position = (c.proportionalStart + d.position / c.length * (c.proportionalEnd - c.proportionalStart)) * width;
            return _react2.default.createElement('line', {
              key: d.variantIdA && d.variantIdB ? d.variantIdA + '-' + d.variantIdB : d.variantId,
              x1: position,
              y1: 0,
              x2: position,
              y2: height,
              stroke: d.inIntersection ? _theme2.default.secondary : _theme2.default.line.color,
              strokeWidth: 2,
              cursor: _onClick ? 'pointer' : 'inherit',
              onClick: function onClick() {
                return _onClick(d);
              }
            });
          })
        )
      ) : null
    )
  );
};

exports.default = (0, _reactMeasure.withContentRect)('bounds')(ManhattanFlat);